import React from "react";
import * as Sentry from "@sentry/react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Crash capturado:", error, info);
    // Reporta ao GlitchTip: sem isto, o ErrorBoundary engole o erro e o crash
    // de tela fica invisível na telemetria (aparece "do nada" pro usuário).
    Sentry.withScope(scope => {
      scope.setTag("boundary", "app-root");
      if (info?.componentStack) {
        scope.setExtra("componentStack", info.componentStack);
      }
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          padding: 32,
          textAlign: "center",
          color: "#555",
        }}>
          <h2>Algo deu errado nesta tela.</h2>
          <p style={{ marginBottom: 16 }}>Recarregue a página para continuar.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 24px",
              background: "#1976d2",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
              fontSize: 15,
            }}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
